import uploadBrowserAudioData from "./uploadBrowserAudioData";
import uploadBrowserFile from "./uploadBrowserFile";

export default function uploadData(props) {
  if (props.media.type === "AUDIO") return uploadBrowserAudioData(props);
  return uploadBrowserFile(props);
}
